<script lang="ts">
import {defineComponent, PropType} from 'vue'
import GlobalFilterPanel from "@global/global-elements/global-filter-panel/global-filter-panel.vue";
import GlobalInputField from "@global/global-elements/global-input-field/global-input-field.vue";
import GlobalFilterGroup from "@global/global-elements/global-filter-group/global-filter-group.vue";
import GlobalDropdown from "@global/global-elements/global-dropdown/global-dropdown.vue";
import SalFilterGroup from "@productfinder/components/sal-filter-group/sal-filter-group.vue";
import GlobalFilter from "@global/global-elements/global-filter/global-filter.vue";
import {MediaGalleryFilterType} from "@src/Resources/epim/Templates/MediaGallery/types/MediaGalleryFilterType";
import {GlobalFilterChangeEvent} from "@global/global-elements/global-filter/GlobalFilterType";
import MediaGallerySelectedFilters from "@src/Resources/epim/Templates/MediaGallery/components/MediaGallerySelectedFilters.vue";

export default defineComponent({
    name: "MediaGalleryFilter",
    components: {MediaGallerySelectedFilters, GlobalFilter, SalFilterGroup, GlobalFilterGroup, GlobalInputField, GlobalFilterPanel, GlobalDropdown},
    props: {
        keyword: {
            type: String,
            default: ""
        },
        filters: {
            type: Array as PropType<MediaGalleryFilterType[]>,
            default() {return []}
        }
    },
    data(): {
        timeout: ReturnType<typeof setTimeout>
    } {
        return {
            timeout: 0
        }
    },
    methods: {
        handleSearchInput(input: string) {
            if (this.timeout) {
                clearTimeout(this.timeout)
            }
            this.timeout = setTimeout(() => {
                this.$emit('keyword', input)
            }, 500)
        },
        handleFilterChange(change: GlobalFilterChangeEvent) {
            this.$store.dispatch('updateFilter', change)
        }
    },
})
</script>

<template>
    <div>
        <global-filter-panel>
            <global-filter-group>
                <global-input-field :label="$t('mediaGallery.filter.keyword.label')" @input="handleSearchInput" :value="keyword"/>
            </global-filter-group>

            <global-filter-group>
                <template v-for="filter in filters">
                    <global-filter :filter="filter" @change="handleFilterChange"/>
                </template>
            </global-filter-group>
        </global-filter-panel>
        <div class="container">
            <media-gallery-selected-filters />
        </div>
    </div>
</template>
